import BottomPanel from './components/BottomPanel/BottomPanel';
import Header from './components/Header/Header'
import Main from './pages/Main/Main'
import About from './pages/About/About'
import Services from './pages/Services/Services'
import Contacts from './pages/Contacts/Contacts'
import { BrowserRouter as Router, Navigate, Routes, Route } from 'react-router-dom';
import Footer from './components/Footer/Footer'
import ScrollToTop from './ScrollToTop';
import Seo from './Seo';
import NotFound from './pages/NotFound/NotFound';

function App() {

  return (
    <Router>
      <div>
        <Seo />
        <Header />
        <ScrollToTop/>
        <Routes>
          <Route path='/' element={<Main />} />
          <Route path='/about' element={<About />} />
          <Route path='/services' element={<Services />} />
          <Route path='/device/*' element={<Navigate to='/' replace />} />
          <Route path='/contacts' element={<Contacts />} />
          <Route path='*' element={<NotFound />} />
        </Routes>
        <BottomPanel />
        <Footer />
      </div>
    </Router>
  );
}

export default App;
